import axios from 'axios'

function isFromcategoriesArray(item) {
  return Object.prototype.isPrototypeOf.call(item, 'selected');
}

function formatValueForTags(item, index, arr) {
  if (!item.selected && !item.value) {
    return []
  }
  const formatted = {
    id: item.id,
    label: item.label,
    value: item.value || item.selected,
    icon: item.icon,
    arr,
    index,
  }
  if (!isFromcategoriesArray(item) && typeof item.value !== 'boolean') {
    formatted.textWithValue = `x ${item.value}`
  }

  return formatted
}

function addSelectedAttribute(cat) {
  return { ...cat, selected: false }
}

const filters = [
  {
    id: 'doors',
    label: 'Portes',
    hover: 'exactement',
    icon: 'door',
    maxValue: 5,
    minValue: 3,
    defaultValue: 0,
    value: 0,
    isCommercialEnabled: false,
  },
  {
    id: 'baggages',
    label: 'Bagages',
    hover: 'à partir de',
    icon: 'baggage',
    maxValue: 5,
    minValue: 1,
    defaultValue: 0,
    value: 0,
    isCommercialEnabled: false,
  },
  {
    id: 'seats',
    label: 'Passagers',
    hover: 'à partir de',
    icon: 'people',
    maxValue: 9,
    minValue: 1,
    defaultValue: 0,
    value: 0,
    isCommercialEnabled: true,
  },
  {
    id: 'is_electric',
    label: 'Electrique',
    icon: 'electric',
    defaultValue: false,
    value: window.renaultRent.ev === true,
    isCommercialEnabled: true,
  },
];

export default {
  namespaced: true,
  state: {
    categories: [],
    filters,
  },
  mutations: {
    SET_CATEGORIES(state, categories) {
      state.categories = categories
    },
    TOGGLE_CATEGORY_SELECT(state, index) {
      const UTILITAIRES_SLUG = 'utilitaires'
      const utilitaireItem = state.categories.find(
        (category) => category.slug === UTILITAIRES_SLUG,
      )
      state.categories[index].selected = !state.categories[index].selected
      // If `utilitaires` is selected, unselect all others categories & reset filters values
      if (
        state.categories[index].slug === UTILITAIRES_SLUG
         && state.categories[index].selected
      ) {
        state.categories = [...state.categories].map((category) => ({
          ...category,
          selected: category.slug !== UTILITAIRES_SLUG ? false : category.selected,
        }))
        state.filters = state.filters.map((filter) => ({ ...filter, value: filter.defaultValue }))
      }
      // If others categories are selected & `utilitaires` was already selected - unselect it
      if (
        utilitaireItem.selected === true
          && state.categories.filter((c) => c.selected === true).length > 1
      ) {
        utilitaireItem.selected = false
        state.filters = state.filters.map((filter) => ({ ...filter, value: filter.defaultValue }))
      }
    },
    INCREASE_FILTER_VALUE(state, payload) {
      const filter = state.filters.find((filterItem) => filterItem.id === payload.id)

      if (!filter.value) {
        filter.value = filter.minValue
        return;
      }

      if (filter.value >= filter.maxValue) {
        filter.value = filter.maxValue
        return;
      }

      filter.value += 1
    },
    DECREASE_FILTER_VALUE(state, payload) {
      const filter = state.filters.find((filterItem) => filterItem.id === payload.id)

      if (filter.value <= filter.minValue) {
        filter.value = 0
        return
      }

      filter.value -= 1
    },
    TOGGLE_BOOLEAN_VALUE(state, payload) {
      const filter = state.filters.find((filterItem) => filterItem.id === payload.id)
      filter.value = !filter.value
    },
    REMOVE_ACTIVE_FILTER(state, payload) {
      if (payload.type === 'category') {
        state.categories = [...state.categories].map((value) => {
          if (payload.filter.id !== value.id) {
            return value
          }
          return {
            ...value,
            selected: false,
          }
        })
      } else if (payload.type === 'filter') {
        state.filters = [...state.filters].map((value) => {
          if (payload.filter.id !== value.id) {
            return value
          }
          return {
            ...value,
            value: value.defaultValue,
          }
        })
      }
    },
  },
  actions: {
    GET_CATEGORIES({ rootState, commit }) {
      axios.get(`${rootState.api}/vehicles/categories`)
        .then((res) => {
          commit('SET_CATEGORIES', res.data.data.map(addSelectedAttribute))
        })
    },
    ACTIVATE_CATEGORY_TYPE({ commit, state }, categoriesArray) {
      commit('SET_CATEGORIES', state.categories.map((category) => ({
        ...category,
        selected: categoriesArray.includes(category.id),
      })))
    },
  },
  getters: {
    activeFilters: (state) => ({
      categories: state.categories.flatMap(formatValueForTags),
      filters: state.filters.flatMap(formatValueForTags),
    }),
    isCommercialVehiculeSelected(state) {
      return state.categories.some((i) => i.slug === 'utilitaires' && i.selected === true)
    },
    commercialVehicleCategoryId(state) {
      const cat = state.categories.find((i) => i.slug === 'utilitaires')
      if (!cat) {
        return
      }
      return cat.id
    },
  },
}
